// Defines a lightweight client-side finn-footer element (the Lit component is only server-rendered)

class FinnFooter extends HTMLElement {
    connectedCallback() {
        // mirror Warp's theme from <html data-w-theme> onto the host so shadow styles can use :host([theme])
        this.syncTheme();
        this.themeObserver = new MutationObserver(() => this.syncTheme());
        this.themeObserver.observe(document.documentElement, { attributeFilter: ['data-w-theme'] });
    }

    disconnectedCallback() {
        this.themeObserver?.disconnect();
    }

    syncTheme() {
        const theme = document.documentElement.getAttribute('data-w-theme');
        if (theme) this.setAttribute('theme', theme);
        else this.removeAttribute('theme');
    }
}
if (!customElements.get('finn-footer')) {
    customElements.define('finn-footer', FinnFooter);
}
